module.exports = __webpack_public_path__ + "static/media/mainheroimg.564df3ee.webp";